// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","default":"#868686","primary":"#56CCF2","primaryLight":"#ABEAFF","wrapper":"_9RTiy6N4CmlPUFn20jOch","navButtons":"sVVHWVDkuFWMntwaU-jIn","task-container":"_2AqgDzFbak2fxJTUbXsZb8","progressTitle":"bcc_IU9es1unDe5IskCyP","task-wrapper":"_7cxTX02Bo28uaAwRbCmkh","preloader":"_1D963Vb1Uz6pTlHd6LEbyI"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Module/Module.mod.css
// module id = 1725
// module chunks = 0